export class AddressDTO {
    addressId?: number;
    firstname?: string;
    lastname?: string;
    nationalCode?: string;
    countryId?: number;
    country?: string;
    provinceId?: number;
    province?: string;
    city?: string|null;
    street?: string;
    postCode?: string;
    phone?: string;
    mobile?: string;
    latitude?: number;
    longitude?: number;
    isDefault = false;
    receiveSelf = false;
}

export default class Address extends AddressDTO{
    constructor(dto?: AddressDTO) {
        super();
        if(dto) {
            Object.assign(this, dto);
        }
    }

    public getReceiverName(): string {
        return `${this.firstname} ${this.lastname}`;
    }

    public getFormData(): FormData {
        const formData = new FormData();
        if(this.addressId) {
            formData.append('addressId', this.addressId.toString());
        }
        if(this.firstname) {
            formData.append('firstname', this.firstname.toString());
        }
        if(this.lastname) {
            formData.append('lastname', this.lastname.toString());
        }
        if(this.nationalCode) {
            formData.append('nationalCode', this.nationalCode.toString());
        }
        if(this.provinceId) {
            formData.append('provinceId', this.provinceId.toString());
        }
        if(this.city) {
            formData.append('city', this.city.toString());
        }
        if(this.street) {
            formData.append('street', this.street.toString());
        }
        if(this.postCode) {
            formData.append('postCode', this.postCode.toString());
        }
        if(this.phone) {
            formData.append('phone', this.phone.toString());
        }
        if(this.mobile) {
            formData.append('mobile', this.mobile.toString());
        }
        if(this.latitude) {
            formData.append('latitude', this.latitude.toString());
        }
        if(this.longitude) {
            formData.append('longitude', this.longitude.toString());
        }
        if(this.isDefault) {
            formData.append('isDefault', this.isDefault.toString());
        }

        return formData;
    }
}

